module.exports = __webpack_public_path__ + "media/images/slides/and_we-838e396c51ddfd13322f8830b0b2c707.jpg";